import React from "react";
import classes from "./style/PageApplications.module.css";
import { ApplicationCard } from "../../components/Application/ApplicationCard/ApplicationCard";

import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { useNavigate } from "react-router-dom";
import { SELECT_FILTER } from "../../store/selectors/applicatoinsSelector";
import { Button, Spin } from "antd";
import { UI_ITOModuleTitle } from "../../UI_ITO/indexUI";
import FilterFrame from "../../components/Application/FilterFrame/FilterFrame";

import { useGetApplicationBankListQuery } from "../../store/api/applicationBankListApi/applicationBank.api";
import { NEXT_PAGE } from "../../store/slices/applicationBankListSlice/applicationBankListSlice";

export const PageApplications = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const applicationBankListFilter = useAppSelector(SELECT_FILTER);
  const { data: applicationListData, isFetching } =
    useGetApplicationBankListQuery(applicationBankListFilter, {
      refetchOnMountOrArgChange: true,
    });
  const onClickLoadMore = () => {
    dispatch(NEXT_PAGE());
  };

  return (
    <>
      <UI_ITOModuleTitle title="Заявки" />

      <FilterFrame />
      <Spin
        spinning={isFetching && applicationBankListFilter.page === 1}
        size="large"
      >
        <div className={classes.bankCarsWrapper}>
          {!!applicationListData?.data?.length && (
            <div>
              {applicationListData?.data?.map((item) => {
                return (
                  <div
                    className={`${classes.applicationCard}`}
                    onClick={() =>
                      navigate(
                        `/application/${item.application.id}/applicationBank/${item.id}`
                      )
                    }
                    key={item.application_id}
                  >
                    <ApplicationCard {...item} />
                  </div>
                );
              })}
            </div>
          )}
          {(applicationListData?.last_page !== applicationBankListFilter.page ||
            isFetching) &&
            applicationListData?.data?.length && (
              <Button
                type="primary"
                style={{ margin: "20px auto 0" }}
                onClick={onClickLoadMore}
                loading={isFetching}
              >
                Загрузить еще
              </Button>
            )}
        </div>

        {applicationListData?.data?.length === 0 && (
          <div>Заявки не найдены</div>
        )}
      </Spin>
    </>
  );
};
